import "./Auticko.scss";

/**
 * Autíčko z loga Rozvozy -- tácka s poklopom na kolesách, s rýchlostnými
 * čiarami vzadu.
 *
 * Je to SVG prekreslené z public/rozvozy_icon_serving_plate.png (súradnice
 * sú priamo z toho obrázka, preto ten zvláštny viewBox). PNG malo 2 MB
 * a natvrdo červenú; toto má pár sto bajtov a farbu prevádzky
 * (`--tenant-primary`, kým nie je známa, farba Rozvozy).
 *
 * Režimy:
 *   stoji      -- bez pohybu (prázdne stavy)
 *   na-mieste  -- pohupuje sa a čiary blikajú (objednávka je na ceste)
 *   prejazd    -- hupká sa, kým ho rodič vezie, potom stojí (potvrdenie
 *                 objednávky; posun robí rodič, viď ObjednavkaPage.scss)
 *   jazda      -- ide dookola zľava doprava; len vnútri AutickoLoader
 *
 * Bez `popis` je čisto ozdobné (aria-hidden) -- text vedľa neho hovorí to isté.
 */
const VYSKA_K_SIRKE = 250 / 580;

function Auticko({ rezim = "stoji", sirka = 96, popis, className = "" }) {
  const pristupnost = popis
    ? { role: "img", "aria-label": popis }
    : { "aria-hidden": true, focusable: "false" };

  return (
    <svg
      className={`auticko auticko--${rezim}${className ? ` ${className}` : ""}`}
      viewBox="460 350 580 250"
      width={sirka}
      height={Math.round(sirka * VYSKA_K_SIRKE)}
      xmlns="http://www.w3.org/2000/svg"
      {...pristupnost}
    >
      <g className="auticko__ciary" fill="currentColor">
        <path d="M578 441 L768 428 L736 462 Z" />
        <path d="M468 512 L740 486 L712 534 Z" />
      </g>
      <g className="auticko__telo" fill="currentColor">
        <circle cx="868" cy="382" r="24" />
        <path d="M700 532 L716 490 L736 456 C772 412 818 392 868 392 C954 392 1018 452 1030 528 Z" />
        <rect x="698" y="524" width="338" height="14" rx="7" />
        <path
          className="auticko__odlesk"
          d="M888 414 C944 422 988 466 1002 514 L968 514 C956 472 928 436 888 414 Z"
        />
      </g>
      <g className="auticko__kolesa" fill="currentColor">
        <ellipse cx="752" cy="568" rx="29" ry="25" />
        <ellipse cx="944" cy="568" rx="29" ry="25" />
      </g>
    </svg>
  );
}

export default Auticko;
